module.exports = __webpack_public_path__ + "static/img/305_phase_function_Paper_PointsHejduk_Prediction.42a5035.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/305_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gYg5
// module chunks = 0